/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordByEmailReqVo
 */
export interface ResetPasswordByEmailReqVo {
    /**
     * 邮箱
     * @type {string}
     * @memberof ResetPasswordByEmailReqVo
     */
    email?: string;
    /**
     * 邮箱验证码
     * @type {string}
     * @memberof ResetPasswordByEmailReqVo
     */
    verificationCode?: string;
}

/**
 * Check if a given object implements the ResetPasswordByEmailReqVo interface.
 */
export function instanceOfResetPasswordByEmailReqVo(value: object): value is ResetPasswordByEmailReqVo {
    return true;
}

export function ResetPasswordByEmailReqVoFromJSON(json: any): ResetPasswordByEmailReqVo {
    return ResetPasswordByEmailReqVoFromJSONTyped(json, false);
}

export function ResetPasswordByEmailReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordByEmailReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'verificationCode': json['verificationCode'] == null ? undefined : json['verificationCode'],
    };
}

export function ResetPasswordByEmailReqVoToJSON(json: any): ResetPasswordByEmailReqVo {
    return ResetPasswordByEmailReqVoToJSONTyped(json, false);
}

export function ResetPasswordByEmailReqVoToJSONTyped(value?: ResetPasswordByEmailReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'verificationCode': value['verificationCode'],
    };
}

